<template>
  <div
    :class="
      `${element.isLock ? 'wrap' : 'wrap cursor'} ${
        element.compData.type
      }-theme-${element.compData.styleId}`
    "
    :style="{
      ...getStyles({
        ...element.compData.styles,
        wrapWidth: element.boxStyle.width,
        wrapHeight: element.boxStyle.height
      })
    }"
  >
    <iframe
      id="iframeBox"
      :ref="element.id"
      frameborder="0"
      scrolling="yes"
      :src="srcParams"
      style="width:100%;height:100%;"
      v-if="element.compData.src"
    ></iframe>
    <div class="iframeTips" v-else>请输入网址/上传网页文件</div>
  </div>
</template>

<script>
import { Button } from "view-design";

export default {
  name: "IframeBoxElement",
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      loading: true,
      srcParams: ""
    };
  },
  methods: {
    getStyles(styles) {
      if (!styles) return;
      const res = {};
      Object.keys(styles).forEach(item => {
        res[`--${item}`] =
          typeof styles[item] === "number" ? styles[item] + "px" : styles[item];
      });
      return Object.assign(res, {
        opacity: this.element["opacity"] / 100
      });
    }
  },
  mounted() {
    this.srcParams = this.element.compData.src;
    // this.srcParams = 'http://localhost:8080/test.html'
    // window.addEventListener('message', data => {
    //   if (data.data.url === this.srcParams) {
    //     console.log(data, '66666666666');
    //     this.$refs[this.element.id].contentWindow.postMessage({parent: '33333333'}, this.srcParams)
    //   }
    // })
    this.$nextTick(() => {
      this.loading = false;
      this.$blueMap.trigger({
        nodeType: "plugin",
        pluginId: this.element.id,
        dataKey: "onmounted",
        eventData: {
          value: this.element.compData,
          data: this.plugin,
          event: null
        }
      });
    });
  },
  components: {
    Button
  }
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;
  #iframeBox {
    html {
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .iframeTips {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    text-align: center;
    padding: 20px 0;
    font-size: 20px;
    color: white;
  }
}
</style>
